import LoginView from "./LoginView.vue";
import AuthenticateView from "./AuthenticateView.vue";

export const authRoutes = [
  {
    path: "/login",
    name: "login",
    meta: { layout: "empty", anonymousOnly: true },
    component: LoginView,
  },
  {
    path: "/authenticate",
    name: "authenticate",
    meta: { layout: "empty", anonymousOnly: true },
    component: AuthenticateView,
  },
];
